<template>
  <div v-show="this.displayed" class="wrapper animated slideIn">
    <div>
      <h1>{{update.data.title}}</h1>
      <p>{{update.data.description}}</p>
    </div>
    <div>
      <quiz v-for="(quiz, qIndex) in update.data.questionList"
        v-bind:key="qIndex"
        :object=quiz
        @selectAnswer="submitAnswer($event)"
      />
      <!-- <div v-for="(quiz, qIndex) in update.data.questionList" v-bind:key="qIndex">
        <h1>{{quiz.question}}</h1>
        <div v-bind:class="['q' + qIndex + ' resp-wrap']">
          <div class="choices isActive"
            v-for="(choice, rIndex) in quiz.responses"
            v-bind:key="rIndex"
            @click="selectAnswer('q' + qIndex)"
          >
            <div></div>
            <p>{{choice.text}}</p>
          </div>
        </div>
        <button @click="submitAnswer(qIndex)">Submit</button>
      </div> -->
    </div>
  </div>
</template>

<script>
import Quiz from '../../components/quiz/Quiz'

export default {
  name: 'Quizzes',
  components: {
    Quiz
  },
  data () {
    return {
      componentData: {}
    }
  },
  props: {
    dataId: {
      type: String,
      required: true
    },
    displayed: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    submitAnswer (isCorrect) {
      alert(isCorrect)
    }
  },
  computed: {
    update () {
      return this.$store.getters.getData(this.dataId)
    }
  },
  mounted () {
  }

}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="./style.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/quizzes/Quizzes.vue